import supabase from '../config/supabaseClient'; 

export const addSponsor = async ({ formData, user_id }) => {
    try {
        // Extract the form fields from the provided formData (which contains the companyBasic fields)
        const { companyName, companyWebsite, companyDescription, companyAddress } = formData;

        // Validate if all required fields are provided
        if (!companyName || !companyAddress || !companyWebsite || !companyDescription) {
            throw new Error('Please provide all required fields: companyName, companyWebsite, companyDescription, and companyAddress');
        }

        // Check if a user with 'fundraiser' role exists in the users table
        const { data: existingFundraiser, error: checkError } = await supabase
            .from('users')
            .select('user_id, role')
            .or(`role.eq.fundraiser,role.eq.admin`)
            .eq('user_id', user_id)
            .single();

        if (checkError) {
            throw checkError;
        }

        // If no fundraiser found with the given user_id, throw an error
        if (!existingFundraiser) {
            throw new Error('No registered fundraiser found with the provided user ID. Please register first.');
        }

        // Insert sponsor data into the 'sponsors' table and link to the fundraiser user
        const { data, error } = await supabase
            .from('sponsors')
            .insert([{
                company_name: companyName,
                company_address: companyAddress,
                company_website: companyWebsite,
                company_description: companyDescription,
                user_id,
                create_date: new Date() 
            }])
            .select();

        if (error) {
            throw error;
        }

        // Return success message and the inserted data
        if (data && data.length > 0) {
            return { data, message: 'Sponsor successfully added' };
        } else {
            throw new Error('Failed to create sponsor: no data returned');
        }
    } catch (error) {
        console.error('Error adding sponsor:', error.message);
        throw new Error(error.message); // Throw the error so it can be caught in the calling function
    }
};
